import React, { useRef, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import ReactPlayer from "react-player/lazy";
import { useTranslation } from "react-i18next";

const ProjectCards = ({
    class_spec,
    categoryTitle,
    categoryId,
    categorySlug, // Yeni prop
    title,
    desc,
    videoURL,
    videoURLWeb,
    thumbnailUrl,
    order,
}) => {
    const { t } = useTranslation();
    const playerRef = useRef(null);
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [isMuted, setIsMuted] = useState(true);
    const [isHovered, setIsHovered] = useState(false);

    const src = videoURLWeb || videoURL || "";

    const handleFullScreen = () => {
        const playerElement = playerRef.current.getInternalPlayer();
        if (playerElement.requestFullscreen) {
            playerElement.requestFullscreen();
        } else if (playerElement.webkitRequestFullscreen) {
            playerElement.webkitRequestFullscreen();
        } else if (playerElement.msRequestFullscreen) {
            playerElement.msRequestFullscreen();
        }
        setIsFullScreen(true);
    };

    const handleVideoClick = () => {
        setIsMuted(false);
    };

    return (
        <motion.div
            className={`project relative py-12 lg:py-24 xl:py-32 ${class_spec}`}
        >
            <motion.div
                initial={{ opacity: 0, translateX: -30 }}
                whileInView={{ opacity: 1, translateX: 0 }}
                transition={{ duration: 0.6 }}
                className={`contain flex lg:gap-36 gap-8 lg:gap-16 flex-col lg:flex-row relative -order-[${order}]`}
                style={{
                    flexDirection:
                        class_spec === "right" ? "row-reverse" : "row",
                }}
            >
                <div className="video-info lg:pr-16 px-4 lg:px-0 flex flex-col lg:w-[50%]">
                    <h2 className="text-xl lg:text-2xl mb-2 uppercase">
                        {categoryTitle}
                    </h2>
                    <h3 className="text-3xl sm:text-5xl break-words lg:text-[clamp(2.5rem,4.5vw,4.5rem)] font-bold uppercase mb-8 !leading-[1.15] lg:mb-16">
                        {title}
                    </h3>
                    <p className="text-base font-light mb-8">{desc}</p>
                    {/* Kategori slug'ını kullanarak yönlendirme */}
                    <Link
                        to={`/projects/${categorySlug || categoryId}`}
                        aria-label={`${t("actions.seeAll")}: ${categoryTitle}`}
                        className={`px-10 font-semibold max-w-fit py-4 mx-auto lg:mx-0 border-[2px] ${
                            class_spec === "right"
                                ? "bg-white text-black border-white lg:bg-black lg:text-white lg:border-white"
                                : "bg-black text-white border-black lg:border-white"
                        }`}
                    >
                        {t("actions.seeAll")}
                    </Link>
                </div>
                <div
                    className={`video-project relative aspect-video overflow-hidden w-full lg:w-[50%] bg-neutral-900 !max-h-[800px] lg:!max-h-[600px] md:!max-h-[400px] sm:!max-h-[300px] ${
                        isFullScreen ? "fullscreen-video" : ""
                    }`}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => {
                        setIsHovered(false);
                        setIsMuted(true);
                    }}
                    onClick={handleVideoClick}
                >
                    {thumbnailUrl && (
                        <img
                            src={thumbnailUrl}
                            alt=""
                            width={1280}
                            height={720}
                            loading="lazy"
                            decoding="async"
                            className="absolute inset-0 w-full h-full object-contain"
                        />
                    )}
                    <ReactPlayer
                        ref={playerRef}
                        url={src}
                        muted={isMuted}
                        playing={!!src}
                        loop
                        controls={isHovered}
                        config={{
                            file: {
                                attributes: {
                                    controlsList: "nodownload",
                                    disablePictureInPicture: true,
                                    preload: "metadata",
                                    playsInline: true,
                                },
                            },
                        }}
                        width="100%"
                        height="100%"
                        className="video-player absolute inset-0"
                    />
                </div>
            </motion.div>

            {/* Fullscreen modunu ayarlamak için gerekli CSS */}
            <style>{`
                .video-player video {
                    object-fit: contain; /* Orijinal oranı korur */
                    width: 100%;
                    height: 100%;
                }
                .fullscreen-video {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100vw;
                    height: 100vh;
                    z-index: 9999;
                }
            `}</style>
        </motion.div>
    );
};

export default ProjectCards;
